import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  BarFilters,
  CreditosMensuales,
  MonthYear,
} from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import { StackedBarChartTooltip } from "../AllEntities/StackedBarChartTooltip";
import FilterParams from "./FilterParams";

interface Props {
  isLoading: boolean;
  monthlyCredits: CreditosMensuales[];
  months: number;
  startMonth: MonthYear | undefined;
  creditsFilters: BarFilters;
  changeMonths: (value: number) => void;
  updateStartingMonth: (month: number, year: number) => void;
  handleToggleCredit: (value: string) => void;
}

const SingleMonthlyCredits: FC<Props> = ({
  isLoading,
  monthlyCredits,
  months,
  startMonth,
  creditsFilters,
  changeMonths,
  updateStartingMonth,
  handleToggleCredit,
}) => {
  /* Dejamos solo los tipos activos */
  const activeTypes = creditsFilters.credits.filter(
    (type) => type.isActive
  );
  return (
    <Card sx={{ width: 1 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#336B87",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          {/* Título */}
          <Typography variant="h6" fontWeight="bold">
            Créditos mensuales
          </Typography>

          {/* Filtros */}
          <FilterParams
            changeMonths={changeMonths}
            months={months}
            startMonth={startMonth}
            updateStartingMonth={updateStartingMonth}
            creditsFilters={creditsFilters}
            handleToggleCredit={handleToggleCredit}
          />
        </Box>
        <ResponsiveContainer width="100%" height={400}>
          {isLoading ? (
            <Box
              sx={{
                height: 1,
                width: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress />
                <Typography
                  variant="body2"
                  mt={2}
                  fontFamily={"Montserrat"}
                  fontSize={16}
                >
                  Cargando créditos mensuales...
                </Typography>
              </Box>
            </Box>
          ) : (
            <BarChart
              data={monthlyCredits}
              margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
              maxBarSize={100}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="month"
                angle={-45}
                textAnchor="end"
                interval={0}
                height={80}
              />
              <YAxis />
              <Tooltip content={<StackedBarChartTooltip />} />
              <Legend
                formatter={(value) => {
                  const map = {
                    creditos_gastados: "Gastados",
                    creditos_disponibles: "Disponibles",
                    creditos_desperdiciados: "Desperdiciados",
                  };
                  return map[value as keyof typeof map] || value;
                }}
              />
              {/* Mostramos las opciones disponibles */}
              {activeTypes.map((type) => {
                return (
                  <Bar
                    key={type.value}
                    dataKey={type.value}
                    stackId="a"
                    fill={type.color}
                  />
                );
              })}
            </BarChart>
          )}
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default SingleMonthlyCredits;
